export default __webpack_public_path__ + "static/media/10.3fbc6740.png";